import React from 'react';

const Note = ({ className = '', title = '' }) => {
  return (
    <svg className={className} width="30" height="33" viewBox="0 0 30 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title lang="en">{title}</title>
      <circle cx="4.88442" cy="27.1735" r="3.38442" fill="#F36A27" stroke="#F36A27" strokeWidth="3"/>
      <circle cx="24.1332" cy="22.2891" r="3.76015" fill="#F36A27" stroke="#F36A27" strokeWidth="3"/>
      <path d="M9.10413 27.5493V6.294L28.6418 2V22.1818" stroke="#F36A27" strokeWidth="2"/>
    </svg>
  )
};

export default Note;
